import {ADD_WORD_ACTION} from '../constants';

const singleWordReducer = (state = '', action) => {
    switch (action.type) {
        case ADD_WORD_ACTION:
            return {
                text: action.newWord,
                isFound: false,
            };
        default:
            return state;
    }
};

export default singleWordReducer;
